import { TransitionStatus } from "@litbase/alexandria";
import { client } from "@litbase/client";
import { map, Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

export interface FileEntry {
  entryId: string;
  status: TransitionStatus;
  file?: File;
  url?: string;
  error?: Error;
  progress?: number;
  preview?: string;
}

export function uploadFileEntry(entry: FileEntry): Observable<FileEntry> {
  if (!entry.file) return throwError(new Error("Trying to upload a FileEntry with no file"));

  return client.uploadFile(entry.file).pipe(
    map((result) => {
      return {
        ...entry,
        ...result,
        status: result.status as unknown as TransitionStatus,
        uri: result.contentUrl,
      };
    }),
    catchError((error) =>
      of<FileEntry>({
        ...entry,
        status: "errored",
        progress: 100,
        error,
      }),
    ),
  );
}
